// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.op-wrap {
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.op-card {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.op-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.op-row .st-input {
  flex: 1;
  min-width: 0;
}
.op-actions {
  display: flex;
  gap: 8px;
}
.op-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--v2-bg);
}
.op-hint {
  margin: 0;
  font-size: 13px;
  color: var(--v2-muted);
}
.op-code {
  font-size: 13px;
  color: var(--v2-text-2);
}
.op-code b {
  display: block;
  margin-top: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 26px;
  letter-spacing: 0.18em;
  color: var(--v2-primary);
  user-select: all;
}

/* --- страница на всю высоту, как тест-чат --- */
.op-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 0;
  overflow: hidden;
  background: #fff;
}
.op-setup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  background: var(--v2-bg);
}

/* --- вкладки в верхней строке --- */
.op-tabs {
  display: flex;
  gap: 2px;
}
.op-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--v2-muted);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.op-tab:hover {
  color: var(--v2-text);
}
.op-tab.is-on {
  background: var(--v2-hover);
  color: var(--v2-primary);
}

/* --- запросы: список слева, переписка справа --- */
.op-inbox {
  flex: 1;
  min-height: 0;
  display: flex;
}
.op-list {
  flex: none;
  width: 256px;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: 8px;
  border-right: 1px solid var(--v2-border-soft);
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.op-list-empty {
  padding: 24px 12px;
  font-size: 13px;
  color: var(--v2-muted);
  text-align: center;
}
.op-li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  text-align: left;
  font: inherit;
  cursor: pointer;
  transition: background 0.4s;
}
.op-li:hover {
  background: var(--v2-bg);
}
.op-li.is-open {
  background: var(--v2-hover);
}
/* Ждёт ответа — подсвечено, пока оператор не ответит. */
.op-li.is-new {
  background: #fef2f2;
}
.op-li.is-new.is-open {
  background: #fde8e8;
}
.op-li.is-new b {
  color: #b91c1c;
}
/* Только что пришло — короткая вспышка. */
.op-li.is-flash {
  animation: op-flash 1.2s ease-out 2;
}
@keyframes op-flash {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.45);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(220, 38, 38, 0);
  }
}
.op-li.is-closed {
  opacity: 0.6;
}
.op-li-ava {
  position: relative;
  flex: none;
}
.op-li-ava .op-dot {
  position: absolute;
  right: -2px;
  top: -2px;
  border: 2px solid #fff;
  box-sizing: content-box;
}
.op-li-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}
.op-li-top {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  min-width: 0;
}
.op-li-top b {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.op-li-time {
  margin-left: auto;
  font-size: 12px;
  color: var(--v2-muted);
  flex-shrink: 0;
}
.op-li-meta {
  font-size: 11px;
  color: var(--v2-faint);
}
.op-li-text {
  font-size: 13px;
  color: var(--v2-text-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.op-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dc2626;
  flex-shrink: 0;
}
.op-chat {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.op-chat-empty {
  margin: auto;
  color: var(--v2-muted);
}
.op-chat-head {
  flex: none;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 56px;
  padding: 0 24px;
  border-bottom: 1px solid var(--v2-border-soft);
}
.op-chat-who {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
  margin-right: auto;
  white-space: nowrap;
  overflow: hidden;
}
.op-chat-who .v2-small {
  overflow: hidden;
  text-overflow: ellipsis;
}
.op-msg {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.op-msg.is-user {
  max-width: 75%;
}
.op-msg.is-operator {
  align-self: flex-end;
  align-items: flex-end;
  max-width: 75%;
}
.op-msg-who {
  font-size: 12px;
  color: var(--v2-faint);
}
.op-bubble {
  padding: 10px 14px;
  border-radius: 16px 16px 16px 4px;
  background: var(--v2-hover);
  color: var(--v2-primary);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.op-msg.is-operator .op-bubble {
  border-radius: 16px 16px 4px 16px;
  background: var(--v2-primary);
  color: #fff;
}
.op-msg.is-operator .op-bubble .v2-link {
  color: #fff;
}
.op-ai {
  overflow-wrap: anywhere;
}
.op-sys {
  align-self: center;
  font-size: 12px;
  color: var(--v2-muted);
}
.op-foot-note {
  flex: none;
  padding: 16px 24px;
  border-top: 1px solid var(--v2-bg);
  text-align: center;
  font-size: 13px;
  color: var(--v2-muted);
}
.op-hint-row select {
  font: inherit;
  border: 1px solid var(--v2-border);
  border-radius: 6px;
  padding: 0 4px;
  background: transparent;
}
.op-empty {
  margin: 60px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: var(--v2-muted);
}
/* Поле ответа: одна строка, текст и стрелка по центру по вертикали. */
.op-input-line {
  align-items: center;
}
/* Файлы клиента: фото превью, документы карточкой с именем. */
.op-files {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
}
.op-photo img {
  display: block;
  max-width: 260px;
  max-height: 220px;
  border-radius: 12px;
  border: 1px solid var(--v2-border-soft);
  object-fit: cover;
}
.op-file {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 320px;
  padding: 10px 14px 10px 10px;
  border-radius: 12px;
  background: var(--v2-hover);
  color: var(--v2-primary);
  text-decoration: none;
}
.op-file:hover {
  background: var(--v2-bg);
}
.op-file-ico {
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--v2-muted);
}
.op-file-body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.op-file-name {
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.op-file-size {
  font-size: 12px;
  color: var(--v2-muted);
}
/* Фото клиента из мессенджера + значок канала в уголке. */
.op-ava {
  position: relative;
  display: block;
  width: 32px;
  height: 32px;
}
.op-ava img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
}
.op-ava-ch {
  position: absolute;
  right: -4px;
  bottom: -4px;
  border-radius: 6px;
  box-shadow: 0 0 0 2px #fff;
  font-size: 6px;
  line-height: 1;
}
.op-ava-ch .ch-badge {
  font-size: 6px;
  border-radius: 5px;
}
.op-file.is-gone {
  opacity: 0.6;
  cursor: default;
}

/* Подключение бота: подпись (что за мессенджер и где взять токен) над полем. */
.op-bot-add {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/operators/operators.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,qEAAqE;EACrE,eAAe;EACf,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;EACE,OAAO;EACP,aAAa;EACb,aAAa;AACf;AACA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA,wDAAwD;AACxD;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA,0CAA0C;AAC1C;EACE,mCAAmC;AACrC;AACA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,0CAA0C;EAC5C;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;AACA,sEAAsE;AACtE;EACE,mBAAmB;AACrB;AACA,8DAA8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB","sourcesContent":[".op-wrap {\n  max-width: 720px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.op-card {\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.op-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n.op-row .st-input {\n  flex: 1;\n  min-width: 0;\n}\n.op-actions {\n  display: flex;\n  gap: 8px;\n}\n.op-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--v2-bg);\n}\n.op-hint {\n  margin: 0;\n  font-size: 13px;\n  color: var(--v2-muted);\n}\n.op-code {\n  font-size: 13px;\n  color: var(--v2-text-2);\n}\n.op-code b {\n  display: block;\n  margin-top: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 26px;\n  letter-spacing: 0.18em;\n  color: var(--v2-primary);\n  user-select: all;\n}\n\n/* --- страница на всю высоту, как тест-чат --- */\n.op-page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  min-width: 0;\n  overflow: hidden;\n  background: #fff;\n}\n.op-setup-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 24px;\n  background: var(--v2-bg);\n}\n\n/* --- вкладки в верхней строке --- */\n.op-tabs {\n  display: flex;\n  gap: 2px;\n}\n.op-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--v2-muted);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.op-tab:hover {\n  color: var(--v2-text);\n}\n.op-tab.is-on {\n  background: var(--v2-hover);\n  color: var(--v2-primary);\n}\n\n/* --- запросы: список слева, переписка справа --- */\n.op-inbox {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n}\n.op-list {\n  flex: none;\n  width: 256px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  padding: 8px;\n  border-right: 1px solid var(--v2-border-soft);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.op-list-empty {\n  padding: 24px 12px;\n  font-size: 13px;\n  color: var(--v2-muted);\n  text-align: center;\n}\n.op-li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  padding: 10px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n  transition: background 0.4s;\n}\n.op-li:hover {\n  background: var(--v2-bg);\n}\n.op-li.is-open {\n  background: var(--v2-hover);\n}\n/* Ждёт ответа — подсвечено, пока оператор не ответит. */\n.op-li.is-new {\n  background: #fef2f2;\n}\n.op-li.is-new.is-open {\n  background: #fde8e8;\n}\n.op-li.is-new b {\n  color: #b91c1c;\n}\n/* Только что пришло — короткая вспышка. */\n.op-li.is-flash {\n  animation: op-flash 1.2s ease-out 2;\n}\n@keyframes op-flash {\n  0% {\n    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.45);\n  }\n  100% {\n    box-shadow: 0 0 0 8px rgba(220, 38, 38, 0);\n  }\n}\n.op-li.is-closed {\n  opacity: 0.6;\n}\n.op-li-ava {\n  position: relative;\n  flex: none;\n}\n.op-li-ava .op-dot {\n  position: absolute;\n  right: -2px;\n  top: -2px;\n  border: 2px solid #fff;\n  box-sizing: content-box;\n}\n.op-li-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n.op-li-top {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  min-width: 0;\n}\n.op-li-top b {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.op-li-time {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--v2-muted);\n  flex-shrink: 0;\n}\n.op-li-meta {\n  font-size: 11px;\n  color: var(--v2-faint);\n}\n.op-li-text {\n  font-size: 13px;\n  color: var(--v2-text-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.op-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #dc2626;\n  flex-shrink: 0;\n}\n.op-chat {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.op-chat-empty {\n  margin: auto;\n  color: var(--v2-muted);\n}\n.op-chat-head {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 56px;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--v2-border-soft);\n}\n.op-chat-who {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  min-width: 0;\n  margin-right: auto;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.op-chat-who .v2-small {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.op-msg {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n}\n.op-msg.is-user {\n  max-width: 75%;\n}\n.op-msg.is-operator {\n  align-self: flex-end;\n  align-items: flex-end;\n  max-width: 75%;\n}\n.op-msg-who {\n  font-size: 12px;\n  color: var(--v2-faint);\n}\n.op-bubble {\n  padding: 10px 14px;\n  border-radius: 16px 16px 16px 4px;\n  background: var(--v2-hover);\n  color: var(--v2-primary);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n.op-msg.is-operator .op-bubble {\n  border-radius: 16px 16px 4px 16px;\n  background: var(--v2-primary);\n  color: #fff;\n}\n.op-msg.is-operator .op-bubble .v2-link {\n  color: #fff;\n}\n.op-ai {\n  overflow-wrap: anywhere;\n}\n.op-sys {\n  align-self: center;\n  font-size: 12px;\n  color: var(--v2-muted);\n}\n.op-foot-note {\n  flex: none;\n  padding: 16px 24px;\n  border-top: 1px solid var(--v2-bg);\n  text-align: center;\n  font-size: 13px;\n  color: var(--v2-muted);\n}\n.op-hint-row select {\n  font: inherit;\n  border: 1px solid var(--v2-border);\n  border-radius: 6px;\n  padding: 0 4px;\n  background: transparent;\n}\n.op-empty {\n  margin: 60px auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: var(--v2-muted);\n}\n/* Поле ответа: одна строка, текст и стрелка по центру по вертикали. */\n.op-input-line {\n  align-items: center;\n}\n/* Файлы клиента: фото превью, документы карточкой с именем. */\n.op-files {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 8px;\n}\n.op-photo img {\n  display: block;\n  max-width: 260px;\n  max-height: 220px;\n  border-radius: 12px;\n  border: 1px solid var(--v2-border-soft);\n  object-fit: cover;\n}\n.op-file {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  max-width: 320px;\n  padding: 10px 14px 10px 10px;\n  border-radius: 12px;\n  background: var(--v2-hover);\n  color: var(--v2-primary);\n  text-decoration: none;\n}\n.op-file:hover {\n  background: var(--v2-bg);\n}\n.op-file-ico {\n  flex: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--v2-muted);\n}\n.op-file-body {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.op-file-name {\n  font-size: 14px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.op-file-size {\n  font-size: 12px;\n  color: var(--v2-muted);\n}\n/* Фото клиента из мессенджера + значок канала в уголке. */\n.op-ava {\n  position: relative;\n  display: block;\n  width: 32px;\n  height: 32px;\n}\n.op-ava img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  display: block;\n}\n.op-ava-ch {\n  position: absolute;\n  right: -4px;\n  bottom: -4px;\n  border-radius: 6px;\n  box-shadow: 0 0 0 2px #fff;\n  font-size: 6px;\n  line-height: 1;\n}\n.op-ava-ch .ch-badge {\n  font-size: 6px;\n  border-radius: 5px;\n}\n.op-file.is-gone {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* Подключение бота: подпись (что за мессенджер и где взять токен) над полем. */\n.op-bot-add {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
